module.exports = __webpack_public_path__ + "img/img-220.0f2eaf98.png";